import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import ShopSuppliersApi from '../generated/api/ShopSuppliers';

export default (service: Servicelayer) => ({
  ...ShopSuppliersApi(service),

  // Add custom calls here

});
